import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { IProduct, IWeeklyTimeRangesStringified, ReactQueryKey, RentalType, UseCustomQueryOptions } from "../../types";


interface IGetProductQueryParams {
    segment: RentalType,
    discountCode: string
}

interface IGetProductParams {
    businessContinuityInsToolMode?: boolean,
    segment: RentalType,
    tenant: string,
    dealer: string
}

export interface IGetProductReturn {
    locations: {
        id: string,
        updatedate: string,
        code: string,
        label: string,
        openings: IWeeklyTimeRangesStringified,
        afterHours: boolean,
        keybox: boolean,
        area: string,
        region: string,
        zone: string,
        ntwId: number,
        specialDayOpenings: {
            date: string,
            timeframes: string
        }[],
        zoneId: string
    }[],
    products: IProduct[],
    segmentCode: string,
    reservedTariff: boolean,
    paymentMethod?: string
}

export const getProduct = async (params: IGetProductParams): Promise<IGetProductReturn> => {
    if(!params.businessContinuityInsToolMode) {
            const response = await axios.get('/booking/instool/product', {
            params: {
                segment: params.segment,
                tenant: params.tenant,
                dealer: params.dealer,
                retrieveDigitalDms: window.location.pathname !== '/booking/insert',
            }
        });
        return response.data;
    } else {
        const response = await axios.get('/booking/instool/productRecovery', {params: {tenant: params.tenant, dealer: params.dealer}});
        return response.data;
    }
};

export const useProductQuery = (
    params: IGetProductParams,
    options?: UseCustomQueryOptions<IGetProductReturn | null>
) => {
    return useQuery<IGetProductReturn | null>({
        queryKey: [ReactQueryKey.Product, {segment: params.segment, tenant: params.tenant, dealer: params.dealer}],
        enabled: params.segment === RentalType.RETAIL,
        queryFn: () => {
            if (params.businessContinuityInsToolMode !== undefined && !!params.tenant && !!params.dealer)
                return getProduct(params);

            return null
        },
        ...options
    })
};
